import React, { useState, useEffect } from "react";

interface Props {
    totalSeconds: number;
    className?: string;
}

const CountdownTimer: React.FC<Props> = ({ totalSeconds, className }) => {
    const [remaining, setRemaining] = useState(totalSeconds);

    useEffect(() => {
        setRemaining(totalSeconds); // reset if prop changes
    }, [totalSeconds]);

    useEffect(() => {
        if (remaining <= 0) return;

        const interval = setInterval(() => {
            setRemaining((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [remaining <= 0]); // only re-register when crossing zero

    if (!remaining || remaining <= 0) return null;

    const hours = Math.floor((remaining % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((remaining % (60 * 60)) / 60);
    const seconds = remaining % 60;

    const format = (num: number) => String(num).padStart(2, "0");

    return (
        <div className={`animate-hurry ${className}`}>
            <div className="flex rounded-lg items-center justify-center px-2 py-1 gap-1 bg-white shadow-sm border border-red-200">

                {/* HOURS */}
                <div className="flex flex-col items-center w-5">
                    <h3 className="font-semibold text-sm text-red-600 leading-none">
                        {format(hours)}
                    </h3>
                    <p className="text-[10px] text-red-500 leading-none">Hr</p>
                </div>

                <span className="text-red-500 text-xs">:</span>

                {/* MINUTES */}
                <div className="flex flex-col items-center w-5">
                    <h3 className="font-semibold text-sm text-red-600 leading-none">
                        {format(minutes)}
                    </h3>
                    <p className="text-[10px] text-red-500 leading-none">Min</p>
                </div>

                <span className="text-red-500 text-xs">:</span>

                {/* SECONDS */}
                <div className="flex flex-col items-center w-5">
                    <h3 className="font-semibold text-sm text-red-600 leading-none">
                        {format(seconds)}
                    </h3>
                    <p className="text-[10px] text-red-500 leading-none">Sec</p>
                </div>

            </div>
        </div>
    );
};

export default CountdownTimer;